import React from 'react';

const steps = [
  {
    title: 'Set up your workspace',
    description: 'Create your account and define what matters now—your role, specialty, interests, or next learning goal.',
  },
  {
    title: 'Curate what is useful',
    description: 'Explore focused modules, save relevant resources, and leave out what does not serve your workflow.',
  },
  {
    title: 'Make the library yours',
    description: 'Search, revisit, create, and selectively share content as your knowledge and responsibilities grow.',
  },
];

const HowItWorksSection: React.FC = () => {
  return (
    <section id="how-it-works" className="section-shell scroll-mt-20">
      <div className="site-container">
        <div className="max-w-2xl">
          <p className="section-kicker">How it works</p>
          <h2 className="section-title">From scattered resources to one working library.</h2>
          <p className="section-copy mt-4">
            Start with what is relevant today. Keep shaping the workspace as your practice,
            study, and interests develop.
          </p>
        </div>

        <ol className="mt-10 grid gap-4 md:grid-cols-3">
          {steps.map((step, index) => (
            <li key={step.title} className="surface-card relative p-6">
              <div className="mb-5 flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-50 text-sm font-semibold text-emerald-700">
                  {index + 1}
                </span>
                {index < steps.length - 1 && (
                  <svg aria-hidden="true" className="hidden h-4 w-4 text-slate-300 md:block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m9 18 6-6-6-6" />
                  </svg>
                )}
              </div>
              <h3 className="text-lg font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-slate-600">{step.description}</p>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex items-start gap-3 rounded-xl border border-emerald-100 bg-emerald-50/60 px-4 py-3 text-sm leading-6 text-slate-600">
          <svg aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          <p>
            Keep clinical decisions grounded in appropriate professional judgment and
            your organization&apos;s approved sources.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;